/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberInvite { 
    /**
     * The Project\'s Revision Creation Date
     */
    readonly created_at: string;
    /**
     * The invite\'s ID.
     */
    readonly id: string;
    /**
     * The invitee\'s email
     */
    invitee_email: string;
    invitee_id?: string | null;
    /**
     * The invite owner\'s email Usually the project\'s owner email
     */
    owner_email: string;
    /**
     * The invite owner\'s ID Usually the project\'s owner
     */
    owner_id: string;
    project_id?: string | null;
    role?: string | null;
    /**
     * The invite\'s status Keeps track of the invites status such as pending, accepted, declined, expired pending PENDING accepted ACCEPTED declined DECLINED expired EXPIRED cancelled CANCELLED removed REMOVED
     */
    status: MemberInvite.StatusEnum;
    /**
     * Last Time Project\'s Revision was Updated
     */
    readonly updated_at: string;
    workspace_id?: string | null;
}
export namespace MemberInvite {
    export type StatusEnum = 'pending' | 'accepted' | 'declined' | 'expired' | 'cancelled' | 'removed';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Accepted: 'accepted' as StatusEnum,
        Declined: 'declined' as StatusEnum,
        Expired: 'expired' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum,
        Removed: 'removed' as StatusEnum
    };
}


